import React ,{useEffect}from 'react';

export default function primer() {
    useEffect(()=>{
        document.title = "TheraMe - Primer";
    },[])
return (
    <div className="container-fluid px-0">
        <div className="container-fluid py-3" style={{ backgroundColor: 'rgb(51, 178, 234)' }}>
            <h2 className="text-white">Therame - Primer</h2>
        </div>
        <div className="container-fluid" style={{ backgroundColor: 'rgb(242, 242, 242)' }}>
            <iframe
                src="/theraMePrimer.pdf"
                width="100%"
                height="600px"
                title="TheraMe Primer"
                style={{ border: '1px solid rgb(204, 204, 204)', display: 'block' }}
            ></iframe>
        </div>
    </div>
);
}
